/* eslint-disable no-nested-ternary */
import { Button, Input, MediaCard, Modal } from '@sendible/design-system/src';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ConnectYoutube, Container, Footer, GridContent, Header } from '../styles/index.styles';
import { genericVideoList } from '../mocks';
import { LoadingState } from '../LoadingState';
import { BlankState } from '../BlankState';
import { useComposeBoxContext } from '../../../composeBoxContext';

export const YoutubeModal = () => {
  const { setIsYoutubeModalOpen } = useComposeBoxContext();
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const { t } = useTranslation(['common_terms', 'compose_box']);

  // Mock states. Replace this with model data/states
  const [hasLoggedIn, setHasLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  // End of mock state

  const handleMediaSelection = (mediaId: string) => {
    if (!selectedItems.includes(mediaId)) setSelectedItems((prev) => [...prev, mediaId]);
    else {
      const newSelection = selectedItems.filter((i) => i !== mediaId);

      setSelectedItems(newSelection);
    }
  };

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 2000);
  }, []);

  const subheaderContent = (
    <Header>
      <Input
        icon="search"
        size="sm"
        label={t('social_media')}
        // eslint-disable-next-line no-console
        change={(value) => console.log(value)}
      />
    </Header>
  );

  return (
    <Modal
      close={() => setIsYoutubeModalOpen(false)}
      footerContent={
        hasLoggedIn ? (
          <Footer>
            <Button
              appearance="primary"
              disabled={selectedItems.length === 0}
              label={t('import_link', { ns: 'compose_box' }) as string}
              // eslint-disable-next-line no-console
              onClick={() => console.log('do something')}
              size={14}
              variation="fill"
            />
          </Footer>
        ) : undefined
      }
      headingAction={
        hasLoggedIn ? (
          <Button
            appearance="primary"
            label={t('change_account') as string}
            onClick={() => setHasLoggedIn((prev) => !prev)}
          />
        ) : undefined
      }
      headingIcon="youtube_color"
      headingTitle={t('youtube') as string}
      subHeaderContent={hasLoggedIn && subheaderContent}
      variation="large"
    >
      <Container>
        {!hasLoggedIn ? (
          <ConnectYoutube>
            <Button
              icon="google_color"
              label={t('continue_with_google') as string}
              onClick={() => setHasLoggedIn(true)}
              size={16}
              variation="outline"
            />
          </ConnectYoutube>
        ) : !isLoading && genericVideoList.length === 0 ? (
          <BlankState />
        ) : (
          <GridContent>
            {isLoading ? (
              <LoadingState />
            ) : (
              genericVideoList.map(({ duration, id, name, thumbUrl, type, updateDate, uploadingText }) => (
                <MediaCard
                  duration={duration}
                  id={id}
                  key={id}
                  name={name}
                  select={() => handleMediaSelection(id)}
                  thumbUrl={thumbUrl}
                  type={type}
                  updateDate={updateDate}
                  uploadingText={uploadingText}
                />
              ))
            )}
          </GridContent>
        )}
      </Container>
    </Modal>
  );
};
